import { useQuery } from '@tanstack/react-query';
import { useSupabaseTypedClient } from 'hooks/reactQuery';

import { TanstackQueryName } from 'types/frontend';

import { CVData, CVSettings, CVTemplate } from '../types';

interface PublicCV {
  title: string;
  template: CVTemplate;
  data: CVData;
  settings: CVSettings;
}

export const useGetPublicCVQuery = (cvId: string | undefined) => {
  const supabase = useSupabaseTypedClient();

  const { data, isFetching } = useQuery({
    queryKey: [TanstackQueryName.GetPublicCV, cvId],
    queryFn: async () => {
      if (!cvId) return null;

      const { data, error } = await supabase
        .from('user_cv')
        .select('title, template, data, settings')
        .eq('id', cvId)
        .eq('is_shared', true)
        .single();

      if (error) return null;

      return data as unknown as PublicCV;
    },
    enabled: Boolean(cvId),
    retry: false,
  });

  return {
    cv: data || null,
    isFetching,
  };
};
